module.exports = __webpack_public_path__ + "img/grand-turk.38effcd5.jpg";